import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { getTextContentFromHtml } from 'sanitize-text/sanitizers/TextSanitizer';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';

const FormattedPropertyHtml = props => {
  const propertyValue = usePropertyValue();
  const {
    className,
    placeholder
  } = props;
  return /*#__PURE__*/_jsx("span", Object.assign({
    className: className
  }, getDataAttributes(props), {
    children: propertyValue ? getTextContentFromHtml(propertyValue) : placeholder
  }));
};

FormattedPropertyHtml.displayName = 'FormattedPropertyHtml';
FormattedPropertyHtml.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.node
};
export default FormattedPropertyHtml;